<template>
  <div class="mobile-index">
    <!-- 首屏 Loading：mobile-hero 内全部 img load/error 后关闭，超时见 PAGE_LOADING_FALLBACK_MS -->
    <div
      v-show="pageLoadingVisible"
      class="mobile-index__page-loading"
      aria-live="polite"
      :aria-busy="pageLoadingVisible ? 'true' : 'false'"
      :aria-label="pcIndexCopy.mobileChrome.loading.ariaLabel"
    >
      <div class="mobile-index__page-loading__inner">
        <img
          class="mobile-index__page-loading__title"
          src="@/assets/image/index/banner_title.webp"
          width="400"
          height="154"
          :alt="pcIndexCopy.mobileChrome.loading.imgAlt"
          decoding="async"
          fetchpriority="high"
        />
      </div>
    </div>

    <!-- TOP -->
    <section id="section-top" ref="bannerWrap" class="mobile-hero">
      <!-- <MobileNav ref="mobileNav" /> -->

      <div class="mobile-hero-bg" aria-hidden="true"></div>
      <div class="mobile-banner">
        <div class="mobile-banner__bg-wrap" aria-hidden="true">
          <div class="mobile-banner__bg-track">
            <img
              v-for="dup in 2"
              :key="'mobile-banner-bg-' + dup"
              class="mobile-banner__bg"
              src="@/assets/image/index/banner.webp"
              alt=""
              width="1490"
              height="840"
              decoding="async"
              :fetchpriority="dup === 1 ? 'high' : 'low'"
            />
          </div>
        </div>
        <div class="mobile-banner-overlay"></div>

        <div class="mobile-banner__logo">
          <img
            class="mobile-banner__logo-image"
            src="@/assets/image/index/banner_title.webp"
            width="400"
            height="154"
            :alt="pcIndexCopy.mobileChrome.a11y.titleArtwork"
            decoding="async"
          />
        </div>
        <div class="mobile-banner__body">
          <div
            v-for="(row, rowIndex) in mobileBannerRows"
            :key="'mobile-banner-row-' + rowIndex"
            class="mobile-banner__body-row"
          >
            <img
              class="mobile-banner__body-image"
              :src="row.image"
              width="240"
              height="60"
              :alt="pcIndexCopy.mobileChrome.a11y.titleArtwork"
              decoding="async"
            />
            <div class="mobile-banner__body-content">
              <span> {{ row.venue }} </span>
              <span>
                {{ row.date }}
                <span
                  v-if="row.dowVariant === 'holiday'"
                  style="color: #ff835d"
                  >{{ row.dow }}</span
                >
                <span v-else class="mobile-banner__body-content--week">{{
                  row.dow
                }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- 无限滚动横幅 (banner 下) -->
      <div class="mobile-marquee mobile-marquee--banner">
        <div class="mobile-marquee-inner">
          <div class="mobile-marquee-track">
            <div
              v-for="dup in 2"
              :key="'mobile-marquee-banner-' + dup"
              class="mobile-marquee-group"
              :aria-hidden="dup === 2 ? 'true' : undefined"
            >
              <img
                v-for="item in 10"
                :key="`mobile-banner-${dup}-${item}`"
                class="mobile-marquee-title"
                src="@/assets/image/index/banner_footer_title.webp"
                width="200"
                height="14"
                :alt="pcIndexCopy.mobileChrome.a11y.marqueeStrip"
                aria-hidden="true"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- NEWS -->
    <section
      id="section-news"
      class="news-section"
      :aria-label="pcIndexCopy.mobileChrome.sectionAria.news"
    >
      <img
        class="news-section__image"
        src="@/assets/image/index/news_title.webp"
        width="380"
        height="36"
        :alt="pcIndexCopy.mobileChrome.a11y.newsSectionTitle"
        decoding="async"
        loading="lazy"
      />
      <!-- NEWS - 迁移 -->
      <div ref="newsScrollRoot" class="news-section__wrapper">
        <div
          class="news-section__item"
          :class="{ 'news-section__item-wait': !item.date }"
          v-for="item in mobileNewsRows"
          :key="item.id"
        >
          <div v-if="item.date">
            <div class="news-section__item-date">
              {{ item.date }}
            </div>
            <div class="news-section__item-content" v-html="item.content"></div>
          </div>
          <div
            v-else
            class="news-section__item-content news-section__item-empty"
          >
            <div class="news-section__item-soon">
              {{ pcIndexCopy.news.comingSoonEn }}
            </div>
            <div>{{ pcIndexCopy.news.comingSoonJa }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- ABOUT -->
    <section
      id="section-about"
      class="about-section"
      :aria-label="pcIndexCopy.mobileChrome.sectionAria.about"
    >
      <div style="position: relative;z-index: 2">
        <!-- <img src="@/assets/image/index/about_mobile_bg.webp" alt=""> -->
        <img
          class="about-section__image"
          src="@/assets/image/index/banner_title.webp"
          width="660"
          height="240"
          :alt="pcIndexCopy.mobileChrome.a11y.titleArtwork"
          decoding="async"
          loading="lazy"
        />
        <div class="about-section__title">
          {{ pcIndexCopy.about.titleLine }}
        </div>
        <div
          class="about-section__content"
          v-html="pcIndexCopy.about.mobileIntroHtml"
        ></div>

        <div class="about-section__tour">
          <div
            v-for="(item, index) in aboutTourList"
            :key="item.id"
            class="about-section__row"
            :style="{ backgroundImage: `url(${cardBgList[index]})` }"
          >
            <div class="about-section__date">
              <div class="about-section__date-wrapper">
                <div class="about-section__date-year">{{ item.year }}</div>
                <span class="about-section__date-day">
                  {{ item.dateDisplay }}
                </span>
                <span
                  class="about-section__date-mark"
                  :style="{ color: index === 3 ? '#FF835D' : '#36e9ff' }"
                >
                  {{ item.dow }}
                </span>
              </div>
            </div>
            <div class="about-section__venue">
              <div
                class="about-section__venue-item"
                v-for="slot in item.slots"
                :key="slot.label"
              >
                <div class="about-section__venue-mark">{{ slot.label }}</div>
                <div>
                  {{ pcIndexCopy.about.slotOpenLabel }} {{ slot.open }}
                </div>
                <div>
                  {{ pcIndexCopy.about.slotStartLabel }} {{ slot.start }}
                </div>
              </div>
            </div>
            <div class="about-section__sale">
                  {{item.goodsSaleLabel}} : {{ item.goodsSaleTime }}
            </div>
            <div class="about-section__location">
              会場 : {{ item.venue }}
            </div>

            <div class="about-section__link">
              <a
                :href="item.mapsUrl"
                target="_blank"
                rel="noopener noreferrer"
                :aria-label="`${item.city} ${item.venue} — ${pcIndexCopy.about.mapLinkAriaSuffix}`"
              >
                <img
                  class="about-section__link-img"
                  :src="cardBtnUrls[index]"
                  width="180"
                  height="30"
                  :alt="`${item.city} ${item.venue} — ${pcIndexCopy.about.mapLinkAltSuffix}`"
                  decoding="async"
                  loading="lazy"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

        <!-- 无限滚动横幅 (about 下) -->
        <div class="mobile-marquee mobile-marquee--about">
          <div class="mobile-marquee-inner">
            <div class="mobile-marquee-track">
              <div
                v-for="dup in 2"
                :key="'mobile-marquee-about-' + dup"
                class="mobile-marquee-group"
                :aria-hidden="dup === 2 ? 'true' : undefined"
              >
                <img
                  v-for="item in 10"
                  :key="`mobile-about-${dup}-${item}`"
                  class="mobile-marquee-title"
                  src="@/assets/image/index/about_footer_title.webp"
                  width="200"
                  height="14"
                  :alt="pcIndexCopy.mobileChrome.a11y.marqueeStrip"
                  aria-hidden="true"
                  decoding="async"
                />
              </div>
            </div>
          </div>
        </div>
    </section>

    <!-- DJ -->
    <section
      id="section-dj"
      class="dj-section"
      :aria-label="pcIndexCopy.mobileChrome.sectionAria.dj"
    >
      <!-- DJ：背景无限横向滚动 -->
      <div class="dj-section__layer" aria-hidden="true">
        <div class="dj-section__layer-track">
          <div
            v-for="dup in 2"
            :key="'dj-bg-slab-' + dup"
            class="dj-section__layer-slab"
          />
        </div>
      </div>

      <div class="dj-section__body">
        <img
          class="dj-section__deputy"
          src="@/assets/image/index/dj_icon.webp"
          width="130"
          height="130"
          :alt="pcIndexCopy.mobileChrome.a11y.djDecorIcon"
          aria-hidden="true"
          decoding="async"
          loading="lazy"
        />
        <div class="dj-section__title">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="122"
            height="29"
            viewBox="0 0 122 29"
            fill="none"
          >
            <g clip-path="url(#clip0_311_3037)">
              <path
                d="M27.2538 18.3299L25.7401 27.568H19.8564L20.0233 26.5479H6.05052L5.88369 27.568H0L2.0182 15.2695H8.74416C8.05244 15.7654 7.65775 16.757 7.40141 18.3299L6.94162 21.1261H10.8559L12.1458 13.2577H8.92726L8.82147 13.8998H2.90929L4.93563 1.54443H11.6901C10.9617 1.92241 10.5955 3.08885 10.327 4.7227L9.81429 7.84H13.0328L14.3186 0H21.4189C20.6214 0.260114 20.1535 1.71919 19.8727 3.40993L19.1444 7.84H22.3914L23.4249 1.54443H30.2078C29.451 1.92241 29.0848 3.08885 28.8163 4.7227L27.3107 13.9039H21.3986L21.5044 13.2618H18.2573L16.9675 21.1302H20.9103L21.8706 15.2736H28.625C27.9048 15.7694 27.5101 16.7611 27.2538 18.334V18.3299Z"
                fill="#FFF380"
              />
              <path
                d="M56.5786 27.8608L49.0958 24.8898L50.8943 22.7642H46.7196L48.4 24.8898H48.3146C47.6758 24.8898 46.8172 25.1825 46.0034 25.5604C43.973 26.4627 40.9701 27.4544 39.4077 27.7755L37.5563 24.2192C39.3955 23.955 41.8043 23.4023 43.6516 22.7601H39.6233L40.2418 19.0007C38.9194 21.5937 37.0314 24.9752 36.063 26.2879C35.8799 26.5196 35.6887 26.987 35.6195 27.3975C35.5991 27.5154 35.5829 27.6292 35.5951 27.7186L31.5994 24.1623C32.6451 23.0853 36.1322 18.07 37.6051 14.9242L40.5063 17.3709L41.6334 10.4941H48.5913L48.7052 9.79508H43.6597L44.0422 7.46218H41.491L41.7921 5.62512L39.8064 7.6654L35.4974 3.90593L39.135 0.085508L42.2681 2.70697L42.4919 1.33731H49.4173L49.637 -0.00390625H56.131C55.7892 0.317172 55.5939 0.6098 55.419 1.33731H62.9831L61.9781 7.45812H59.4838L59.1014 9.79101H53.9989L53.885 10.4901H60.8429L58.8287 22.7601H54.2797L59.5611 24.3046L56.5705 27.8608H56.5786ZM38.3497 14.4243L33.6257 10.8965L36.8849 6.93382L41.5927 10.4007L38.3538 14.4243H38.3497ZM47.3014 18.3301H45.5029L45.3443 19.2933H47.1427L47.3014 18.3301ZM48.0257 13.9285H46.2272L46.0726 14.8592H47.8711L48.0257 13.9285ZM57.2825 5.53571H46.8782L46.7643 6.23477H57.1686L57.2825 5.53571ZM54.4017 18.3301H52.6033L52.4446 19.2933H54.243L54.4017 18.3301ZM55.126 13.9285H53.3275L53.1729 14.8592H54.9714L55.126 13.9285Z"
                fill="#FFF380"
              />
              <path
                d="M70.763 0.889648H82.8681C85.2525 0.889648 87.1283 1.21479 88.4914 1.86508C89.8545 2.51536 90.9124 3.45015 91.6733 4.66943C92.4342 5.88872 92.894 7.30309 93.0649 8.92067C93.2317 10.5383 93.1666 12.2493 92.8696 14.0579C92.4057 16.8907 91.7222 19.0895 90.827 20.6502C89.9278 22.2109 88.8251 23.5196 87.5108 24.5763C86.1965 25.633 84.8619 26.3321 83.4948 26.6857C81.6271 27.1693 79.971 27.4091 78.5184 27.4091H66.4133L70.763 0.889648ZM77.9284 6.89666L75.5522 21.3858H77.55C79.2508 21.3858 80.4959 21.1948 81.2772 20.8168C82.0584 20.4388 82.7298 19.7723 83.2954 18.8253C83.8569 17.8783 84.3126 16.3461 84.6625 14.2205C85.1223 11.4121 84.984 9.48967 84.2434 8.44921C83.5029 7.41282 82.0747 6.89259 79.967 6.89259H77.9325L77.9284 6.89666Z"
                stroke="#FFF380"
              />
              <path
                d="M112.498 0.889648H120.665L118.3 15.2975C117.804 18.3214 117.161 20.6217 116.368 22.2027C115.574 23.7797 114.284 25.1209 112.49 26.2142C110.696 27.3116 108.543 27.8602 106.024 27.8602C103.363 27.8602 101.357 27.4985 100.015 26.7751C98.6719 26.0516 97.7116 24.9949 97.1461 23.6009C96.5764 22.2068 96.3892 20.4876 96.5805 18.4352L104.543 17.3663C104.364 18.5368 104.324 19.4025 104.421 19.9715C104.519 20.5405 104.767 20.9957 105.166 21.3452C105.439 21.5728 105.866 21.6906 106.44 21.6906C107.351 21.6906 108.075 21.3492 108.612 20.6705C109.149 19.9918 109.552 18.8416 109.817 17.2281L112.498 0.889648Z"
                fill="#FFF380"
                stroke="#FFF380"
              />
            </g>
            <defs>
              <clipPath id="clip0_311_3037">
                <rect width="121.145" height="28.2671" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div class="dj-section__list">
          <div
            v-for="(item, index) in djList"
            :key="index"
            class="dj-section__list-row"
          >
            <!-- <div style="background-color: #000000;"> -->
            <img
              class="dj-section__list-img"
              :src="item.icon"
              width="200"
              height="200"
              :alt="`${pcIndexCopy.mobileChrome.djPortraitAltPrefix}${item.name}`"
              decoding="async"
              loading="lazy"
            />
            <!-- </div> -->
            <div class="dj-section__list-name">
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="dj-section__footer">
          {{ pcIndexCopy.dj.footerNote }}
        </div>
      </div>

      <!-- 无限滚动横幅 (dj 下) -->
      <div class="mobile-marquee mobile-marquee--dj">
        <div class="mobile-marquee-inner">
          <div class="mobile-marquee-track">
            <div
              v-for="dup in 2"
              :key="'mobile-marquee-dj-' + dup"
              class="mobile-marquee-group"
              :aria-hidden="dup === 2 ? 'true' : undefined"
            >
              <img
                v-for="item in 10"
                :key="`mobile-dj-${dup}-${item}`"
                class="mobile-marquee-title"
                src="@/assets/image/index/about_footer_title.webp"
                width="200"
                height="14"
                :alt="pcIndexCopy.mobileChrome.a11y.marqueeStrip"
                aria-hidden="true"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- TICKET -->
    <section
      class="ticket-section"
      :aria-label="pcIndexCopy.mobileChrome.sectionAria.ticket"
    >
      <img
        class="ticket-section__title"
        :class="{ 'ticket-section__title--compact': mobileTicketSectionTitleCompact }"
        :src="mobileTicketSectionTitleImg"
        :width="mobileTicketSectionTitleCompact ? undefined : 282"
        :height="mobileTicketSectionTitleCompact ? 29 : 72"
        :alt="pcIndexCopy.mobileChrome.a11y.ticketingTitle"
        decoding="async"
        loading="lazy"
      />

      <div class="ticket-section__info">
        <img
          class="ticket-section__info-logo"
          src="@/assets/image/logo/yostation.webp"
          width="100"
          height="100"
          :alt="pcIndexCopy.mobileChrome.a11y.yoStationLogo"
          decoding="async"
          loading="lazy"
        />
        <span class="ticket-section__info-name">
          {{ pcIndexCopy.ticketYoStation.brandName }}
        </span>

        <div class="ticket-section__info-text">
          <div>{{ pcIndexCopy.ticketYoStation.capsuleLeft }}</div>
          <div>{{ pcIndexCopy.ticketYoStation.capsuleRight }}</div>
        </div>
        <div class="ticket-section__info-tips">
          {{ pcIndexCopy.ticketYoStation.appBoxLabel }}
        </div>
        <!-- <div
          class="ticket-section__info-link ticket-section__info-share1"
          @click="openTicketQrModal"
        > -->
        <a
          :href="pcIndexLinks.ticketInquiryFormFirst"
          class="ticket-section__info-link ticket-section__info-share1"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span> {{ pcIndexCopy.ticketYoStation.mobileDownloadCta }}</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
          >
            <path
              d="M12.6855 0.232481L2.64335 10.3306L3.74085 11.4342L13.783 1.3361L12.6855 0.232481Z"
              fill="#FFF380"
            />
            <path
              d="M14 4.77592H12.4479V1.56076H9.23503V0H14V4.77592Z"
              fill="#FFF380"
            />
            <path
              d="M12.3703 14H0V1.56076H6.17738V3.02787H1.45898V12.5173H10.8958V7.77257H12.3703V14Z"
              fill="#FFF380"
            />
            <path
              d="M12.6855 0.232481L2.64335 10.3306L3.74085 11.4342L13.783 1.3361L12.6855 0.232481Z"
              fill="#FFF380"
            />
            <path
              d="M14 4.77592H12.4479V1.56076H9.23503V0H14V4.77592Z"
              fill="#FFF380"
            />
          </svg>
        </a>
      <!-- </div> -->
        <div class="ticket-section__info-tips">
          {{ pcIndexCopy.ticketYoStation.contactBoxLabel }}
        </div>
        <a
          :href="pcIndexLinks.ticketInquiryForm"
          class="ticket-section__info-link ticket-section__info-share2"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span> {{ pcIndexCopy.ticketYoStation.inquiryCta }}</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
          >
            <path
              d="M12.6855 0.232481L2.64335 10.3306L3.74085 11.4342L13.783 1.3361L12.6855 0.232481Z"
              fill="#36E9FF"
            />
            <path
              d="M14 4.77592H12.4479V1.56076H9.23503V0H14V4.77592Z"
              fill="#36E9FF"
            />
            <path
              d="M12.3703 14H0V1.56076H6.17738V3.02787H1.45898V12.5173H10.8958V7.77257H12.3703V14Z"
              fill="#36E9FF"
            />
            <path
              d="M12.6855 0.232481L2.64335 10.3306L3.74085 11.4342L13.783 1.3361L12.6855 0.232481Z"
              fill="#36E9FF"
            />
            <path
              d="M14 4.77592H12.4479V1.56076H9.23503V0H14V4.77592Z"
              fill="#36E9FF"
            />
          </svg>
        </a>
      </div>
      <div class="ticket-section__body">
        <article
          v-for="item in ticketAddressList"
          :key="item.id"
          class="ticket-section__row"
        >
          <img
            class="ticket-section__row-logo"
            :src="item.logo"
            width="360"
            height="200"
            :alt="`${pcIndexCopy.mobileChrome.a11y.venueGraphicPrefix}${item.title}`"
            decoding="async"
            loading="lazy"
          />
          <div
            class="ticket-section__row-card"
            :style="{
              borderColor: item.color,
            }"
          >
            <div
              class="ticket-section__row-title"
              :style="{ color: item.color }"
            >
              {{ item.title }}
            </div>
            <div
              v-for="row in item.priceRows"
              :key="row.num + '-' + row.label"
              class="ticket-section__row-price"
            >
              <span class="ticket-section__row-price--label">
                <span>{{ row.num }}</span>
                <span>{{ row.label }}</span>
              </span>
              <span class="ticket-section__row-price--value">
                {{ row.price }}
                <span>{{ pcIndexCopy.ticket.priceTaxSuffix }} </span>
              </span>
            </div>
          </div>
        </article>
      </div>
      <div class="ticket-section__more">
        <router-link :to="mobileIndexLinks.ticketPage">
          <img
            src="@/assets/image/index/mobile_ticket_more_1.webp"
            width="238"
            height="40"
            :alt="pcIndexCopy.imgAlt.ticketMore"
            decoding="async"
            loading="lazy"
          />
        </router-link>
      </div>

      <div
        v-if="showTicketWrapMessageAndMoreLinks"
        class="ticket-section__footer"
      >
        <div class="ticket-section__footer-message">
          <div class="ticket-section__footer-message-lead">
            <div class="ticket-section__footer-message-head">
              <h3 class="ticket-section__footer-message-title">
                {{ streamingTicket.title }}
              </h3>
              <p class="ticket-section__footer-message-price">
                {{ streamingTicket.price }}
              </p>
            </div>
            <div
              class="ticket-section__footer-message-divider"
              role="presentation"
              aria-hidden="true"
            />
            <div class="ticket-section__footer-message-period">
              <span class="ticket-section__footer-message-badge">
                {{ streamingTicket.periodBadge }}
              </span>
              <p class="ticket-section__footer-message-range">
                {{ streamingTicket.periodRange }}
              </p>
            </div>
          </div>
          <a
            class="ticket-section__footer-message-button"
            :href="streamingTicket.purchaseUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>{{ streamingTicket.purchaseCta }}</span>
            <svg
              class="ticket-section__footer-message-button-icon"
              viewBox="0 0 8 12"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M1.5 1L6.5 6L1.5 11"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </a>
        </div>
        <div class="ticket-section__footer-message--more">
          <router-link :to="mobileIndexLinks.streamingPage">
            <img
              src="@/assets/image/index/mobile_ticket_more_2.webp"
              width="238"
              height="40"
              :alt="pcIndexCopy.imgAlt.streamingMore"
              decoding="async"
              loading="lazy"
            />
          </router-link>
        </div>
      </div>
    </section>

    <!-- GOODS -->
    <section
      v-if="showHomeGoodsSection"
      class="goods-section"
      :aria-label="pcIndexCopy.mobileChrome.sectionAria.goods"
    >
      <img
        class="goods-section__title"
        src="@/assets/image/index/mobile_goods_title.webp"
        :alt="pcIndexCopy.mobileChrome.a11y.goodsBanner"
      />
      <img
        src="@/assets/image/index/goods_banner.webp"
        :alt="pcIndexCopy.mobileChrome.a11y.goodsBanner"
        class="goods-section__content"
      />
      <router-link :to="mobileIndexLinks.goodsPage">
        <img
          src="@/assets/image/index/mobile_goods_more.webp"
          :alt="pcIndexCopy.imgAlt.goodsMore"
          width="240"
          height="40"
          class="goods-section__more"
        />
      </router-link>
    </section>

    <!-- YoStation 下载二维码全屏弹窗 -->
    <transition name="mobile-ticket-qr-modal">
      <div
        v-show="ticketQrModalVisible"
        class="mobile-index__ticket-qr-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="mobile-index-ticket-qr-modal-title"
        @click.self="closeTicketQrModal"
      >
        <h2
          id="mobile-index-ticket-qr-modal-title"
          class="mobile-index__ticket-qr-modal__sr-only"
        >
          {{ pcIndexCopy.ticketQrModal.dialogTitle }}
        </h2>
        <button
          type="button"
          class="mobile-index__ticket-qr-modal__close"
          :aria-label="pcIndexCopy.ticketQrModal.closeLabel"
          @click="closeTicketQrModal"
        >
          <img
            src="@/assets/image/detail/close.webp"
            width="40"
            height="40"
            alt=""
            decoding="async"
          />
        </button>
        <div class="mobile-index__ticket-qr-modal__inner">
          <div class="mobile-index__ticket-qr-modal__qr-frame">
            <img
              class="mobile-index__ticket-qr-modal__qr"
              src="@/assets/image/logo/qr.webp"
              width="360"
              height="360"
              :alt="pcIndexCopy.imgAlt.yoStationQr"
              decoding="async"
            />
          </div>
          <p class="mobile-index__ticket-qr-modal__caption">
            {{ pcIndexCopy.ticketQrModal.caption }}
          </p>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/**
 * 运营维护：文案、列表、外链与地图前缀与 PC 同源，见 @/views/data/index-content.json
 *（pcIndexCopy / pcIndexLinks；站内路由仅 H5 不同见 mobileIndexLinks）
 */
import SimpleBar from "simplebar";
import "simplebar/dist/simplebar.css";
import indexContent from "@/views/data/index-content.json";
import streamingContent from "@/views/data/streaming-content.json";
import contentVisibility from "@/views/data/content-visibility.json";
import {
  decodeRouteHashAnchorId,
  scrollToAnchorById,
  afterScrollSettled,
} from "@/utils/mobile-anchor";
import {
  setMobileHomeActiveSectionByScroll,
  setMobileHomeActiveSectionAnchorIdImmediate,
  resetMobileHomeActiveSectionAnchor,
} from "@/utils/mobile-home-active-section";

/** 票务场馆条 logo（顺序与 index-content.json ticketAddressList 一致） */
const MOBILE_INDEX_TICKET_ADDRESS_LOGOS = [
  require("@/assets/image/index/address_logo_1.webp"),
  require("@/assets/image/index/address_logo_2.webp"),
  require("@/assets/image/index/address_logo_3.webp"),
  require("@/assets/image/index/address_logo_4.webp"),
  require("@/assets/image/index/address_logo_5.webp"),
];

/** DJ 头像（顺序与 index-content.json djList 一致） */
const MOBILE_INDEX_DJ_ICONS = [
  require("@/assets/image/index/dj_team_1.webp"),
  require("@/assets/image/index/dj_team_2.webp"),
  require("@/assets/image/index/dj_team_3.webp"),
  require("@/assets/image/index/dj_team_4.webp"),
];

/** 首屏横幅下列配图（id 与 aboutTourList.id 一致） */
const MOBILE_BANNER_IMG_BY_ID = {
  sapporo: require("@/assets/image/index/mobile_sapporo.webp"),
  fukuoka: require("@/assets/image/index/mobile_fukuoka.webp"),
  nagoya: require("@/assets/image/index/mobile_nagoya.webp"),
  osaka: require("@/assets/image/index/mobile_osaka.webp"),
  tokyo: require("@/assets/image/index/mobile_tokyo.webp"),
};

/** mobile-hero 内图片迟迟未全部 load/error 时强制关闭首屏 Loading，避免卡死 */
const PAGE_LOADING_FALLBACK_MS = 8000;

export default {
  name: "MobileIndex",
  data() {
    const aboutTourList = indexContent.aboutTourList.map(
      ({ mapsQuery, ...rest }) => ({
        ...rest,
        mapsUrl:
          indexContent.pcIndexLinks.googleMapsSearchBase +
          encodeURIComponent(mapsQuery),
      }),
    );
    return {
      pcIndexCopy: indexContent.pcIndexCopy,
      streamingTicket: streamingContent.pcStreamingCopy.liveTicket,
      pcIndexLinks: indexContent.pcIndexLinks,
      mobileIndexLinks: indexContent.mobileIndexLinks,
      mobileBannerRows: aboutTourList.map((t) => ({
        image: MOBILE_BANNER_IMG_BY_ID[t.id],
        venue: t.venue,
        date: t.dateDisplay,
        dow: t.dow,
        dowVariant:
          t.dow &&
          (String(t.dow).includes("祝") || String(t.dow).includes("・"))
            ? "holiday"
            : "week",
      })),
      pageLoadingVisible: true,
      _pageLoadingFallbackTimer: null,
      ticketQrModalVisible: false,
      newsSimpleBar: null,
      newsList: indexContent.newsList,
      aboutTourList,
      cardBgList: [
        require("@/assets/image/index/card_bg_1.webp"),
        require("@/assets/image/index/card_bg_2.webp"),
        require("@/assets/image/index/card_bg_3.webp"),
        require("@/assets/image/index/card_bg_4.webp"),
        require("@/assets/image/index/card_bg_5.webp"),
      ],
      cardBtnUrls: [
        require("@/assets/image/index/card_btn_1.webp"),
        require("@/assets/image/index/card_btn_2.webp"),
        require("@/assets/image/index/card_btn_3.webp"),
        require("@/assets/image/index/card_btn_4.webp"),
        require("@/assets/image/index/card_btn_5.webp"),
      ],
      djList: indexContent.djList.map((row, i) => ({
        ...row,
        icon: MOBILE_INDEX_DJ_ICONS[i],
      })),
      ticketAddressList: indexContent.ticketAddressList.map((row, i) => ({
        ...row,
        logo: MOBILE_INDEX_TICKET_ADDRESS_LOGOS[i],
      })),
    };
  },
  computed: {
    /** content-visibility.json → home */
    showTicketWrapMessageAndMoreLinks() {
      return (
        contentVisibility.home?.showTicketWrapMessageAndMoreLinks !==
        false
      );
    },
    /** content-visibility.json → home */
    showHomeGoodsSection() {
      return contentVisibility.home?.showHomeGoodsSection !== false;
    },
    /** header.showStreamingNav：与 PC 票务标题图逻辑一致 */
    mobileTicketSectionTitleImg() {
      const showStreaming =
        contentVisibility.header?.showStreamingNav !== false;
      return showStreaming
        ? require("@/assets/image/index/mobile_ticket_title.webp")
        : require("@/assets/image/index/mobile_ticket_title1.webp");
    },
    /** false 为 ticket_title1，标题高度 29px 居中 */
    mobileTicketSectionTitleCompact() {
      return contentVisibility.header?.showStreamingNav === false;
    },
    /** 与 PC 首页 NEWS 占位规则一致 */
    mobileNewsRows() {
      const real = this.newsList || [];
      const n = real.length;
      let p = 0;
      if (n <= 0) p = 2;
      else if (n === 1) p = 1;
      const placeholders = Array.from({ length: p }, (_, i) => ({
        id: "news-placeholder-" + i,
        date: null,
        content: null,
      }));
      return [...real, ...placeholders];
    },
  },
  mounted() {
    this.initPageLoadingBannerGate();
    this.initNewsSimpleBar();
    this.scrollToRouteHashIfAny();
    this.initMobileHomeSectionSpy();
  },
  beforeDestroy() {
    this.teardownMobileHomeSectionSpy();
    this.clearPageLoadingFallbackTimer();
    document.removeEventListener("keydown", this._onTicketQrModalKeydown);
    if (this.ticketQrModalVisible) {
      document.body.style.overflow = "";
    }
    this.destroyNewsSimpleBar();
  },
  methods: {
    clearPageLoadingFallbackTimer() {
      if (this._pageLoadingFallbackTimer != null) {
        clearTimeout(this._pageLoadingFallbackTimer);
        this._pageLoadingFallbackTimer = null;
      }
    },
    dismissPageLoading() {
      if (!this.pageLoadingVisible) return;
      this.pageLoadingVisible = false;
      this.clearPageLoadingFallbackTimer();
    },
    /** 统计 mobile-hero 内所有 img 的 load/error（已 complete 立即计入），齐后关 Loading */
    initPageLoadingBannerGate() {
      this._pageLoadingFallbackTimer = setTimeout(() => {
        this.dismissPageLoading();
      }, PAGE_LOADING_FALLBACK_MS);

      this.$nextTick(() => {
        const root = this.$refs.bannerWrap;
        if (!root) {
          this.dismissPageLoading();
          return;
        }
        const imgs = root.querySelectorAll("img");
        const total = imgs.length;
        if (total === 0) {
          this.dismissPageLoading();
          return;
        }
        let remaining = total;
        const onOne = () => {
          remaining -= 1;
          if (remaining <= 0) {
            this.dismissPageLoading();
          }
        };
        imgs.forEach((img) => {
          if (img.complete) {
            onOne();
          } else {
            img.addEventListener("load", onOne, { once: true });
            img.addEventListener("error", onOne, { once: true });
          }
        });
      });
    },
    initNewsSimpleBar() {
      this.$nextTick(() => {
        this.$nextTick(() => {
          const el = this.$refs.newsScrollRoot;
          if (!el || this.newsSimpleBar) return;
          this.newsSimpleBar = new SimpleBar(el, {
            autoHide: false,
            forceVisible: "y",
          });
          if (typeof this.newsSimpleBar.recalculate === "function") {
            this.newsSimpleBar.recalculate();
          }
        });
      });
    },
    destroyNewsSimpleBar() {
      if (this.newsSimpleBar) {
        this.newsSimpleBar.unMount();
        this.newsSimpleBar = null;
      }
    },
    openTicketQrModal() {
      document.removeEventListener("keydown", this._onTicketQrModalKeydown);
      document.addEventListener("keydown", this._onTicketQrModalKeydown);
      this.ticketQrModalVisible = true;
      document.body.style.overflow = "hidden";
    },
    closeTicketQrModal() {
      this.ticketQrModalVisible = false;
      document.body.style.overflow = "";
      document.removeEventListener("keydown", this._onTicketQrModalKeydown);
    },
    _onTicketQrModalKeydown(e) {
      if (e.key === "Escape") {
        this.closeTicketQrModal();
      }
    },
    /*
     * 原实现：通过首页内 <MobileNav ref="mobileNav" /> 调用 scrollToAnchorById；
     * MobileNav 迁至 Layout 后 ref 不存在，初始化 hash 滚动失效。
     *
    scrollToRouteHashIfAny() {
      const raw = this.$route.hash;
      if (!raw || raw === "#") return;
      let id;
      try {
        id = decodeURIComponent(raw.slice(1));
      } catch {
        id = raw.slice(1);
      }
      if (!id) return;
      this.$nextTick(() => {
        const nav = this.$refs.mobileNav;
        if (!nav || typeof nav.scrollToAnchorById !== "function") return;
        const ok = nav.scrollToAnchorById(id);
        const clearHash = () => {
          if (!this.$route.hash) return;
          this.$router.replace({
            path: this.$route.path,
            query: this.$route.query,
            hash: "",
          });
        };
        if (!ok) {
          clearHash();
          return;
        }
        let finished = false;
        const onDone = () => {
          if (finished) return;
          finished = true;
          clearHash();
        };
        if (typeof window !== "undefined" && "onscrollend" in window) {
          window.addEventListener("scrollend", onDone, { once: true });
        }
        setTimeout(onDone, 900);
      });
    },
    */
    /** 根据当前路由 hash 滚动到对应 section，滚动结束后清除 hash（逻辑见 @/utils/mobile-anchor） */
    scrollToRouteHashIfAny() {
      const id = decodeRouteHashAnchorId(this.$route.hash);
      if (!id) return;
      this.$nextTick(() => {
        const ok = scrollToAnchorById(id);
        const clearHash = () => {
          if (!this.$route.hash) return;
          this.$router.replace({
            path: this.$route.path,
            query: this.$route.query,
            hash: "",
          });
          this.$nextTick(() => {
            setMobileHomeActiveSectionByScroll();
          });
        };
        if (!ok) {
          clearHash();
          return;
        }
        afterScrollSettled(clearHash);
      });
    },

    /** 与 MobileNav 联动：hash 会被清空，用滚动位置同步当前 section */
    initMobileHomeSectionSpy() {
      if (typeof window === "undefined") return;
      this._onMobileHomeScroll = () => {
        if (this._mobileHomeSectionRaf != null) return;
        this._mobileHomeSectionRaf = requestAnimationFrame(() => {
          this._mobileHomeSectionRaf = null;
          setMobileHomeActiveSectionByScroll();
        });
      };
      window.addEventListener("scroll", this._onMobileHomeScroll, {
        passive: true,
      });
      window.addEventListener("resize", this._onMobileHomeScroll, {
        passive: true,
      });
      this.$nextTick(() => {
        const id = decodeRouteHashAnchorId(this.$route.hash);
        if (id) {
          setMobileHomeActiveSectionAnchorIdImmediate(id);
        } else {
          setMobileHomeActiveSectionByScroll();
        }
      });
    },
    teardownMobileHomeSectionSpy() {
      if (typeof window !== "undefined" && this._onMobileHomeScroll) {
        window.removeEventListener("scroll", this._onMobileHomeScroll);
        window.removeEventListener("resize", this._onMobileHomeScroll);
      }
      if (this._mobileHomeSectionRaf != null) {
        cancelAnimationFrame(this._mobileHomeSectionRaf);
        this._mobileHomeSectionRaf = null;
      }
      this._onMobileHomeScroll = null;
      resetMobileHomeActiveSectionAnchor();
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile-index {
  min-height: 100vh;
  background: #0a0c1f;
  color: #f7f9ff;
  font-family: "Noto Sans JP", "Noto Sans", sans-serif;

  &__news {
  }
}

/* 首页首屏 Loading：与 PC 首页 ticket-qr / page-loading 视觉一致 */
.mobile-index__page-loading {
  position: fixed;
  inset: 0;
  z-index: 250;
  background-color: #35353c;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: env(safe-area-inset-top, 0) 24px env(safe-area-inset-bottom, 0);
  box-sizing: border-box;
  border-top: 2px solid #c84cff;
  border-bottom: 2px solid #c84cff;
  box-shadow: 0 -8px 22px -2px rgba(191, 0, 255, 0.55),
    0 8px 22px -2px rgba(191, 0, 255, 0.55),
    0 -18px 40px -6px rgba(200, 76, 255, 0.35),
    0 18px 40px -6px rgba(200, 76, 255, 0.35);

  &__inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    max-width: 100%;
  }

  &__title {
    display: block;
    width: min(400px, 92vw);
    max-width: 100%;
    height: auto;
    object-fit: contain;
    object-position: center;
    transform-origin: center center;
    will-change: transform;
    animation: mobile-index-page-loading-beat 1.35s infinite;
  }

  @media (prefers-reduced-motion: reduce) {
    &__title {
      animation: none !important;
    }
  }
}

/* YoStation 下载 QR 全屏弹窗（对齐 pc/index/index.vue .pc-index__ticket-qr-modal） */
.mobile-index__ticket-qr-modal {
  position: fixed;
  inset: 0;
  z-index: 200;
  background-color: #35353c;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: calc(56px + env(safe-area-inset-top, 0)) 20px
    calc(24px + env(safe-area-inset-bottom, 0));
  box-sizing: border-box;
  border-top: 2px solid #c84cff;
  border-bottom: 2px solid #c84cff;
  box-shadow: 0 -8px 22px -2px rgba(191, 0, 255, 0.55),
    0 8px 22px -2px rgba(191, 0, 255, 0.55),
    0 -18px 40px -6px rgba(200, 76, 255, 0.35),
    0 18px 40px -6px rgba(200, 76, 255, 0.35);

  &__sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  &__close {
    position: absolute;
    top: calc(16px + env(safe-area-inset-top, 0));
    right: max(16px, env(safe-area-inset-right, 0));
    width: 40px;
    height: 40px;
    padding: 0;
    margin: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
    border-radius: 50%;
    transform-origin: center center;
    -webkit-tap-highlight-color: transparent;
    transition: transform 0.24s cubic-bezier(0.34, 1.45, 0.64, 1),
      filter 0.2s ease, background-color 0.2s ease, box-shadow 0.24s ease;

    img {
      display: block;
      width: 40px;
      height: 40px;
      object-fit: contain;
      pointer-events: none;
      transition: transform 0.24s cubic-bezier(0.34, 1.45, 0.64, 1),
        filter 0.2s ease;
    }

    &:active {
      transform: scale(0.92);
      filter: brightness(0.92);
      transition-duration: 0.08s;

      img {
        transform: rotate(90deg) scale(0.95);
        transition-duration: 0.08s;
      }
    }

    &:focus-visible {
      outline: 2px solid #fff380;
      outline-offset: 2px;
    }
  }

  &__inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    max-width: 100%;
  }

  &__qr-frame {
    background-color: #fff;
    padding: 16px;
    box-sizing: border-box;
    line-height: 0;
    max-width: 100%;
    border-radius: 8px;
    overflow: hidden;
  }

  &__qr {
    display: block;
    width: 360px;
    height: 360px;
    max-width: 100%;
    max-height: min(360px, 50vh);
    object-fit: contain;
  }

  &__caption {
    margin: 20px 0 0;
    padding: 0;
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.5;
    text-align: center;
  }
}

.mobile-index__ticket-qr-modal.mobile-ticket-qr-modal-enter-active,
.mobile-index__ticket-qr-modal.mobile-ticket-qr-modal-leave-active {
  transition: opacity 0.32s cubic-bezier(0.4, 0, 0.2, 1);
}

.mobile-index__ticket-qr-modal.mobile-ticket-qr-modal-enter-active
  .mobile-index__ticket-qr-modal__inner,
.mobile-index__ticket-qr-modal.mobile-ticket-qr-modal-leave-active
  .mobile-index__ticket-qr-modal__inner {
  transition: transform 0.4s cubic-bezier(0.34, 1.18, 0.64, 1),
    opacity 0.32s ease;
}

.mobile-index__ticket-qr-modal.mobile-ticket-qr-modal-enter,
.mobile-index__ticket-qr-modal.mobile-ticket-qr-modal-leave-to {
  opacity: 0;
}

.mobile-index__ticket-qr-modal.mobile-ticket-qr-modal-enter
  .mobile-index__ticket-qr-modal__inner,
.mobile-index__ticket-qr-modal.mobile-ticket-qr-modal-leave-to
  .mobile-index__ticket-qr-modal__inner {
  opacity: 0;
  transform: scale(0.92) translateY(20px);
}

@media (prefers-reduced-motion: reduce) {
  .mobile-index__ticket-qr-modal.mobile-ticket-qr-modal-enter-active,
  .mobile-index__ticket-qr-modal.mobile-ticket-qr-modal-leave-active {
    transition: none !important;
  }

  .mobile-index__ticket-qr-modal.mobile-ticket-qr-modal-enter-active
    .mobile-index__ticket-qr-modal__inner,
  .mobile-index__ticket-qr-modal.mobile-ticket-qr-modal-leave-active
    .mobile-index__ticket-qr-modal__inner {
    transition: none !important;
  }

  .mobile-index__ticket-qr-modal.mobile-ticket-qr-modal-enter
    .mobile-index__ticket-qr-modal__inner,
  .mobile-index__ticket-qr-modal.mobile-ticket-qr-modal-leave-to
    .mobile-index__ticket-qr-modal__inner {
    transform: none !important;
    opacity: 1 !important;
  }

  .mobile-index__ticket-qr-modal__close,
  .mobile-index__ticket-qr-modal__close img {
    transition: none !important;
  }

  .mobile-index__ticket-qr-modal__close:active {
    transform: none !important;
    filter: none !important;
  }

  .mobile-index__ticket-qr-modal__close:active img {
    transform: none !important;
  }
}

.mobile-hero {
  position: relative;
  text-align: center;
  color: #ffffff;
  background-color: #1b1d48;
}
.mobile-banner {
  position: relative;
  width: 100%;
  height: 1000px;
  overflow: hidden;
  background-color: #cfcef6;

  &__logo {
    position: relative;
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 34px;

    &-image {
      width: 400px;
      height: 154px;
      animation: logoFloat 6s ease-in-out infinite;
    }
  }

  &__body {
    position: relative;
    z-index: 9;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding-top: 178px;

    /* 矮屏才缩小与标题图的间距；常规机型保持 178px */
    @media (max-height: 812px) {
      padding-top: 72px;
    }
    @media (max-height: 700px) {
      padding-top: 36px;
    }
    @media (max-height: 620px) {
      padding-top: 12px;
    }

    &-image {
      width: 240px;
      height: 60px;
      margin: 0 auto 2px;
    }
    &-content {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      width: 100%;
      height: 32px;
      padding: 0 8px;
      line-height: 32px;
      border-radius: 100px;

      font-weight: 700;
      font-size: 16px;
      line-height: 100%;
      letter-spacing: 0%;

      background: rgba(0, 0, 0, 0.8);

      &--week {
        color: #36e9ff;
      }
    }
  }

  &__bg-wrap {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
    width: 100%;
    height: 840px;
    overflow: hidden;
  }

  &__bg-track {
    display: flex;
    width: max-content;
    height: 100%;
    animation: mobile-banner-bg-marquee 30s linear infinite;
    will-change: transform;

    @media (prefers-reduced-motion: reduce) {
      animation: none;
      will-change: auto;
    }
  }

  &__bg {
    flex-shrink: 0;
    width: 1490px;
    height: 840px;
    object-fit: cover;
    display: block;
  }

  &-overlay {
    position: absolute;
    /* width: 100%; */
    left: 0;
    right: 0;
    // bottom: 0;
    top: 760px;
    height: 80px;
    // background-color: #ff3040;
    background: linear-gradient(
      180deg,
      rgba(193, 190, 237, 0) 0%,
      #cfcef6 100%
    );
    z-index: 9;
  }
}
.mobile-hero-bg {
  position: absolute;
  inset: 0;
  background: rgba(11, 15, 39, 0.6);
  z-index: 0;
}
.mobile-hero-content {
  position: relative;
  z-index: 1;
  padding: 12px 15px 18px;
}
.mobile-hero h1 {
  margin: 0 0 8px;
  font-size: 1.15rem;
  font-weight: 700;
}
.mobile-hero p {
  margin: 0;
  font-size: 0.85rem;
  opacity: 0.9;
}

.news-section {
  position: relative;
  padding: 68px 30px 80px;
  font-family: "Noto Sans JP", "Noto Sans", sans-serif;
  background: linear-gradient(
    180deg,
    rgba(131, 108, 167, 1) 0%,
    rgba(60, 48, 104, 1) 100%
  );

  &__image {
    width: 379px;
    height: 35px;
    margin-bottom: 34px;
  }

  &__item + &__item {
    margin-top: 16px;
    margin-bottom: 20px;
  }

  &__item {
    // height: 140px;
    padding: 28px 30px;
    border-radius: 8px;
    border: 1px solid #fff380;
    background: rgba(0, 0, 0, 0.25);
    text-align: left;
    box-sizing: border-box;

    &-wait {
      height: 104px;
    }

    &-date {
      margin-bottom: 20px;
      color: #37fff1;
      font-size: 20px;
      font-weight: 600;
      line-height: 100%;
    }
    &-content {
      color: #fff;
      font-size: 14px;
      font-weight: 500;
      line-height: 150%;
    }

    &-empty {
      display: flex;
      align-items: center;
      gap: 26px;
      padding: 10px 0;
      // min-height: 50px;
      box-sizing: border-box;
    }

    &-soon {
      color: #898989;
      font-size: 24px;
      font-weight: 600;
      line-height: 100%; /* 24px */
    }
  }

  /* 高度与滚动由 SimpleBar 接管。
   * SimpleBar 6 会把宿主元素的 padding 同步到 .simplebar-content 的 inline style，
   * 因此「与滚动条间距」必须写在 &__wrapper 上，不能仅写在外层 .simplebar-content 选择器里。 */
  &__wrapper {
    width: 100%;
    height: 400px;
    max-height: 400px;
    box-sizing: border-box;
    /* 右：10px 视觉间距 + 2px 轨道；底：略增高可滚区域（占位条较矮时仍能滚动） */
    padding: 0 12px 4px 0;
    overflow: visible;
  }
}

.about-section {
  position: relative;
  padding: 40px 50px 100px;
  font-family: "Noto Sans JP", "Noto Sans", sans-serif;
  background-image: url(@/assets/image/index/mobile_about_bg.webp);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: scroll;
  background-color: #12111a;
  animation: BackgroundFloat 14s ease-in-out infinite;
  border-top: 2px solid #c391e5;

  z-index: 1;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;

    /* 上层：图标 / 下层：方点 */
    background-image: url(@/assets/image/index/mobile_about_bg_icon.webp);
    background-size: auto;
    background-position: center;
    background-repeat: no-repeat;

    /* 🔥 流畅自然动效：全程可见，无消失、无断层 */
    animation: BackgroundFloat 6s ease-in-out infinite;

    z-index: 1;
  }

  &__image {
    margin: 0 auto 20px;
  }

  &__title {
    margin-bottom: 20px;
    padding: 0 20px;
    color: #37fff1;
    text-align: center;
    font-size: 24px;
    font-weight: 800;
    line-height: 150%;
  }

  &__content {
    margin-bottom: 30px;
    color: #fff;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    line-height: 200%;
  }

  &__tour {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 26px;
  }

  &__row {
    display: flex;
    flex-direction: column;
    width: 246px;
    height: 352px;
    padding: 96px 0 14px;
    box-sizing: border-box;
    font-size: 14px;
    color: #fff;
    font-weight: 700;
    font-family: "Noto Sans JP", "Noto Sans", sans-serif;
    background-repeat: no-repeat;
    background-size: cover;
  }

  &__date {
    margin-bottom: 18px;
    text-align: center;

    &-wrapper {
      position: relative;
      display: inline-block;
    }

    &-year {
      position: absolute;
      top: -12px;
      color: #fff;
      font-size: 10px;
      font-weight: 500;
      line-height: 1;
    }
    &-mark {
      color: #36e9ff;
      font-size: 16px;
      font-weight: 700;
      line-height: 1;
      letter-spacing: 1.6px;
    }
    &-day {
      font-size: 40px;
      font-weight: 700;
      line-height: 1;
      letter-spacing: 3px;
    }
  }
  &__venue:last-child {
    margin-bottom: 20px;
  }
  &__venue {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 46px;
    margin-bottom: 16px;
    font-weight: 500;

    &-item {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      line-height: 1.35;
    }

    &-mark {
      display: flex;
      align-items: center;
      padding: 2px 8px;
      border-radius: 2px;
      background: #4ec4fb;
      color: #191616;
      font-size: 10px;
      font-weight: 700;
      line-height: 100%;
    }
  }
  &__sale {
    margin-bottom: 8px;
    font-weight: 700;
    line-height: 1.35;
    text-align: center;
  }
  &__location {
    margin-top: 8px;
    margin-bottom: 16px;
    font-weight: 700;
    line-height: 1.35;
    text-align: center;
  }

  &__link {
    padding: 0 30px;
    flex-shrink: 0;
    line-height: 0;

    a {
      display: block;
      width: 100%;
    }
    &-img {
      display: block;
      width: 100%;
      height: auto;
    }
  }
}

.dj-section {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 120px 40px 126px;
  background-color: #3c3068;

  &__layer {
    position: absolute;
    inset: 0;
    z-index: 1;
    overflow: hidden;
    pointer-events: none;

    &-track {
      display: flex;
      height: 100%;
      width: max-content;
      animation: dj-section-bg-marquee 20s linear infinite;
      will-change: transform;

      @media (prefers-reduced-motion: reduce) {
        animation: none;
        will-change: auto;
      }
    }

    &-slab {
      flex-shrink: 0;
      width: 100vw;
      min-height: 918px;
      height: 100%;
      background-image: url("@/assets/image/index/mobile_dj_bg.webp");
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }
  }

  &__body {
    position: relative;
    padding: 56px 0 64px;
    background: rgba(18, 17, 26, 0.8);
    border-top: 2px solid #d9a2ff;
    border-bottom: 2px solid #d9a2ff;
    z-index: 2;
  }

  &__deputy {
    position: absolute;
    top: -76px;
    left: -26px;
    width: 130px;
    height: 130px;
    z-index: 3;
  }
  &__title {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 50px;
  }

  &__list {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 40px;
    margin-bottom: 40px;

    &-img {
      margin-bottom: 12px;
    }

    &-name {
      width: 200px;
      padding: 8px 20px;
      margin: 0 auto;
      border-radius: 32px;
      border: 1px solid #fff380;
      background: rgba(0, 0, 0, 0.25);
      color: #fff;
      font-size: 16px;
      font-weight: 700;
      line-height: 100%;
      letter-spacing: 3.2px;
    }
  }

  &__footer {
    color: #a6a6a6;
    font-size: 10px;
    font-weight: 700;
    line-height: 100%;
    letter-spacing: 2px;
  }
}

.ticket-section {
  padding: 100px 40px 96px;
  background-color: #12111a;
  border-bottom: 3px solid #936dac;
  // background-image: url("@/assets/image/index/about_bg.webp");
  background-image: url(@/assets/image/index/mobile_about_bg.webp);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: scroll;
  background-color: #12111a;
  animation: BackgroundFloat 10s ease-in-out infinite;

  &__title {
    display: block;
    margin: 0 auto 52px;
    object-fit: contain;
    object-position: center;

    &--compact {
      width: auto;
      max-width: 100%;
      height: 29px;
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 40px;
    padding: 40px 80px;
    border-radius: 8px;
    border: 1px solid #fff380;
    background: rgba(0, 0, 0, 0.25);

    &-logo {
      margin-bottom: 8px;
    }

    &-name {
      margin-bottom: 28px;
      color: #fff;
      font-size: 18px;
      font-weight: 700;
      line-height: 100%;
    }

    &-text div:first-child {
      margin-bottom: 10px;
    }
    &-text {
      margin-bottom: 28px;
      color: #36e9ff;
      text-align: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 100%;
    }

    &-tips {
      width: 100%;
      // margin-bottom: 10px;
      padding: 2px 0;
      text-align: center;
      border: 1px solid #fff;
    }

    &-link {
      display: flex;
      // align-items: center;
      justify-content: center;
      gap: 4px;
      width: 100%;
      padding: 10px 0;
      font-size: 14px;
      font-weight: 600;
      line-height: 100%;
      text-align: center;
    }

    &-share1 {
      margin-bottom: 36px;
      border-bottom: 1px solid #fff380;
      color: #fff380;
    }
    &-share2 {
      margin-bottom: 18px;
      color: #36e9ff;
      border-bottom: 1px solid #36e9ff;
    }
  }

  &__body {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    padding: 0 16px;
  }

  &__row {
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    line-height: 150%;

    &-logo {
      margin-bottom: 12px;
    }

    &-card {
      // display: flex;
      // flex-direction: column;
      // align-items: center;
      // justify-self: center;
      // gap: 6px;
      padding: 38px 40px;
      border-width: 1px;
      border-style: solid;
      border-radius: 4px;
      background: rgba(137, 137, 137, 0.1);
      text-align: left;
    }

    &-title {
      margin-bottom: 6px;
    }

    &-price + &-price {
      margin-top: 2px;
    }

    &-price {
      display: flex;
      align-items: center;
      justify-content: space-between;

      font-weight: 700;
      font-size: 14px;
      line-height: 150%;

      &--label span + span {
        margin-left: 6px;
      }

      &--value span {
        font-weight: 700;
        font-size: 8px;
      }
    }
  }

  &__more {
    padding: 40px 60px 60px;
  }

  &__footer {
    width: 100%;

    &-message {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 24px;
      padding: 34px 28px;
      border-radius: 8px;
      border: 1px solid #d9a2ff;
      background: rgba(0, 0, 0, 0.25);
      text-align: center;

      &-head {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
      }

      &-title {
        margin: 0;
        color: #d9a2ff;
        font-size: 18px;
        font-weight: 800;
        line-height: 1.35;
        letter-spacing: 0;
      }

      &-price {
        margin: 0;
        color: #fff;
        font-size: 14px;
        font-weight: 700;
        line-height: 1.45;
      }

      &-divider {
        height: 0;
        margin: 14px 0 18px;
        border-top: 2px solid rgba(255, 255, 255, 0.55);
      }

      &-period {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        gap: 10px;
      }

      &-badge {
        min-width: 78px;
        padding: 5px 12px;
        box-sizing: border-box;
        background-color: rgba(0, 0, 0, 0.35);
        color: #fff;
        font-size: 12px;
        font-weight: 800;
        line-height: 1;
        text-align: center;
        white-space: nowrap;
      }

      &-range {
        margin: 0;
        color: #fff;
        text-align: center;
        font-size: 14px;
        font-weight: 700;
        line-height: 1.45;
      }

      &-button {
        align-self: center;
        flex-shrink: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 14px;
        width: 158px;
        height: 30px;
        box-sizing: border-box;
        border: 2px solid #d9a2ff;
        border-radius: 999px;
        color: #d9a2ff;
        background-color: transparent;
        text-decoration: none;
        font-size: 12px;
        font-weight: 800;
        line-height: 1;
        -webkit-tap-highlight-color: transparent;
        transition: color 0.18s ease, background-color 0.18s ease,
          transform 0.18s ease, filter 0.18s ease;

        &:hover,
        &:focus-visible {
          color: #191616;
          background-color: #d9a2ff;
        }

        &:active {
          transform: scale(0.96);
          filter: brightness(0.92);
        }
      }

      &-button-icon {
        width: 8px;
        height: 12px;
        animation: mobile-ticket-button-nudge 1.1s ease-in-out infinite;
        will-change: transform;
      }

      @media (prefers-reduced-motion: reduce) {
        &-button-icon {
          animation: none;
          will-change: auto;
        }
      }

      &--more {
        padding: 40px 60px 0;
      }
    }
  }
}

.goods-section {
  position: relative;
  width: 100%;
  padding: 78px 32px 100px;
  background-color: #fff48b;
  background-image: url("@/assets/image/index/goods_bg.webp");
  background-size: cover;
  background-repeat: no-repeat;
  border-bottom: 3px solid #9f77bb;

  &__title {
    margin-bottom: 28px;
  }

  &__content {
    width: 100%;
    aspect-ratio: 5/2;
    margin-bottom: 50px;
  }

  &__more {
    margin: 0 auto;
  }
}
.mobile-section {
  padding: 18px 16px;
  background: #0e1228;
  border-top: 1px solid #2d3557;
}
.mobile-section h2 {
  margin: 0 0 12px;
  font-size: 0.95rem;
  font-weight: 700;
  color: #70d4ff;
}

.mobile-news-list,
.mobile-about-cards,
.mobile-dj-grid,
.mobile-ticket-list,
.mobile-goods-grid {
  display: grid;
  gap: 10px;
}

.news-item {
  background: #161d37;
  border-radius: 10px;
  padding: 10px;
}
.news-date {
  display: block;
  color: #85d4ff;
  font-size: 0.75rem;
  margin-bottom: 4px;
}
.news-content {
  margin: 0;
  font-size: 0.8rem;
}

.about-card {
  background: #1d2a4e;
  border-radius: 10px;
  padding: 11px;
}
.about-card-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
  font-size: 0.74rem;
  font-weight: 700;
}
.about-venue {
  margin: 0 0 8px;
  font-size: 0.78rem;
  color: #eeeff9;
}
.about-slots {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.slot-chip {
  background: #2b3b72;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 0.68rem;
}

.mobile-dj-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.dj-card {
  background: #16204a;
  border-radius: 10px;
  padding: 10px;
  text-align: center;
}
.dj-avatar {
  width: 100%;
  max-width: 110px;
  height: auto;
  margin: 0 auto 8px;
}
.dj-name {
  margin: 0;
  font-size: 0.82rem;
  font-weight: 700;
}

.mobile-ticket-list {
  grid-template-columns: 1fr;
}
.ticket-card {
  background: #1d2a4e;
  border-radius: 10px;
  padding: 10px;
}
.ticket-logo {
  width: 100%;
  max-width: 160px;
  object-fit: contain;
  margin-bottom: 8px;
}
.ticket-price-row {
  display: flex;
  justify-content: space-between;
  font-size: 0.76rem;
  margin-top: 4px;
}

.mobile-goods-grid img {
  width: 100%;
  border-radius: 10px;
  filter: saturate(1.1);
}

/* 无限滚动横幅 */
.mobile-marquee {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 60px;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;

  &--banner {
    position: absolute;
    bottom: -18px;
    z-index: 9;
    background-image: url("@/assets/image/index/banner_footer_bg.webp");
  }

  &--about {
    position: absolute;
    bottom: -30px;
    left: 0;
    right: 0;
    z-index: 9;
    background-image: url("@/assets/image/index/about_footer_bg.webp");
  }

  &--dj {
    position: absolute;
    bottom: -30px;
    left: 0;
    right: 0;
    z-index: 9;
    background-image: url("@/assets/image/index/about_footer_bg.webp");
  }

  &-inner {
    width: 100%;
    height: 24px;
    overflow: hidden;
    background-color: #191616;
    display: flex;
    align-items: center;
    border-top: 2px solid #fff590;
    border-bottom: 2px solid #fff590;

    .mobile-marquee--about & {
      border-top-color: #d9a2ff;
      border-bottom-color: #d9a2ff;
    }

    .mobile-marquee--dj & {
      border-top-color: #d9a2ff;
      border-bottom-color: #d9a2ff;
    }
  }

  &-track {
    display: flex;
    width: max-content;
    flex-shrink: 0;
    align-items: center;
    animation: mobile-marquee 30s linear infinite;
    will-change: transform;

    @media (prefers-reduced-motion: reduce) {
      animation: none;
      will-change: auto;
    }
  }

  &-group {
    display: flex;
    flex-shrink: 0;
    align-items: center;
  }

  &-title {
    flex-shrink: 0;
    margin-right: 20px;
    width: 200px;
    height: 10px;
    object-fit: contain;
    object-position: center;
  }
}

/* 无限滚动动画 */
@keyframes mobile-ticket-button-nudge {
  0%,
  100% {
    transform: translateX(0);
  }
  42% {
    transform: translateX(4px);
  }
  68% {
    transform: translateX(0);
  }
}
@keyframes mobile-marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

/* 首屏 banner 底图：双联横向无缝向左滚 */
@keyframes mobile-banner-bg-marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

/* 与 PC @keyframes pc-index-page-loading-beat 一致 */
@keyframes mobile-index-page-loading-beat {
  0%,
  42% {
    transform: scale(1);
    animation-timing-function: cubic-bezier(0.45, 0, 0.55, 1);
  }
  52% {
    transform: scale(0.9);
    animation-timing-function: cubic-bezier(0.55, 0.05, 0.6, 0.45);
  }
  58% {
    transform: scale(0.86);
    animation-timing-function: cubic-bezier(0.33, 1.15, 0.52, 1);
  }
  70% {
    transform: scale(1.08);
    animation-timing-function: cubic-bezier(0.22, 0.85, 0.38, 1);
  }
  80% {
    transform: scale(1);
    animation-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes dj-section-bg-marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

/* =============================
   🔥 核心动效：全程可见 + 放大缩小 + 柔和浮动
   无消失！无断层！不突然闪现！
============================= */
@keyframes BackgroundFloat {
  0% {
    background-position: center, center;
    background-size: 100% auto, auto; /* 原始大小 */
    opacity: 0.9; /* 全程保持可见 */
  }
  25% {
    background-position: calc(50% + 6px) calc(50% - 4px), center;
    background-size: 104% auto, auto; /* 温和放大 */
    opacity: 1; /* 轻微变亮 */
  }
  50% {
    background-position: calc(50% - 4px) calc(50% + 6px), center;
    background-size: 107% auto, auto; /* 最大放大（不突兀） */
    opacity: 1; /* 最亮 */
  }
  75% {
    background-position: calc(50% + 3px) calc(50% + 3px), center;
    background-size: 104% auto, auto; /* 缩小 */
    opacity: 0.95; /* 微暗 */
  }
  100% {
    background-position: center, center; /* 回到原位 */
    background-size: 100% auto, auto; /* 回到原始大小 */
    opacity: 0.9; /* 回到初始亮度 */
  }
}

@keyframes logoFloat {
  0% {
    transform: translateY(0) scale(1);
  }
  50% {
    transform: translateY(-8px) scale(1.03);
  }
  100% {
    transform: translateY(0) scale(1);
  }
}
</style>

<style lang="scss">
/* SimpleBar：轨道 #37FFF199、滑块 #FFF380；与内容区间距由宿主 .news-section__wrapper padding-right 提供 */
.news-section__wrapper[data-simplebar] {
  .simplebar-content-wrapper {
    -webkit-overflow-scrolling: touch;
  }

  .simplebar-track.simplebar-vertical {
    width: 2px !important;
    top: 0;
    bottom: 0;
    background-color: #37fff199;
    border-radius: 4px;
  }

  .simplebar-track.simplebar-horizontal {
    display: none;
  }

  .simplebar-scrollbar::before {
    left: 0 !important;
    right: 0 !important;
    top: 0 !important;
    bottom: 0 !important;
    border-radius: 4px !important;
    background-color: #fff380 !important;
    opacity: 1 !important;
    transition: none !important;
  }

  .simplebar-scrollbar.simplebar-visible::before {
    opacity: 1 !important;
  }
}
</style>
